module.exports = __webpack_public_path__ + "img/rank-1.3.adc62599.svg";